import {React, Component} from 'react'
import {BrowserRouter as Router, Link} from "react-router-dom";

import './Header.css';


class Header extends Component {
  constructor(props){
    super(props)
    this.state = {
      
    }
  }


  render(){
    return (
      <div className="Header">
                              
                              
          <Link  className="nav-link" to="/"> Home </Link>
          <Link  className="nav-link" to="/classify"> Classify </Link>
          <Link  className="nav-link" to="/search"> Search </Link>
          {/* <Link  className="nav-link" to="/faqs"> Faqs </Link> */}
          <Link  className="nav-link" to="/myglyphs"> My Glyphs </Link>
         
      </div>
                              
    
    );
  
  }
}

export default Header;
